import React, { useState, useRef } from "react";
import { Card, Button, Modal, Form } from "react-bootstrap";
import {
  FiEdit,
  FiTrash2,
  FiDownload,
  FiImage,
  FiMessageCircle,
} from "react-icons/fi";

import { FiUpload,  } from "react-icons/fi";
export default function NotesTab() {
  const [activeComment, setActiveComment] = useState(null);

  const [showImage, setShowImage] = useState(false);
  const fileRef = useRef();
const [showAdd, setShowAdd] = useState(false);
  const [files, setFiles] = useState([
    {
      name: "Projectneonals teyys.xls",
      size: "4.25 MB",
      progress: 45,
    },
    {
      name: "tes.txt",
      size: "1.2 MB",
    },
  ]);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles([
        ...files,
        {
          name: file.name,
          size: (file.size / 1024 / 1024).toFixed(2) + " MB",
          progress: 30,
        },
      ]);
    }
  };

  const removeFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFiles(updated);
  };

  const [selectedSort, setSelectedSort] = useState('Last 7 Days');

  const sortOptions = [
    { value: 'recently-added', label: 'Recently Added' },
    { value: 'ascending',      label: 'Ascending' },
    { value: 'descending',     label: 'Descending' },
    { value: 'last-month',     label: 'Last Month' },
    { value: 'last-7-days',    label: 'Last 7 Days' },
  ];
  
  return (
    <div className="notes-wrapper p-3">

      {/* HEADER */}
   <div className="notes-header mb-3">
  <h6 className="fw-semibold mb-0">Notes</h6>

  <div className="header-actions">
    
    <div className="sort-group">
      <span className="sort-label">Sort By :</span>

      <div className="sort-wrapper position-relative">
        <select
          className="form-select sort-select"
          value={selectedSort}
          onChange={(e) => setSelectedSort(e.target.value)}
        >
          <option value="last-7-days">Last 7 Days</option>
          <option value="recently-added">Recently Added</option>
          <option value="ascending">Ascending</option>
          <option value="descending">Descending</option>
          <option value="last-month">Last Month</option>
        </select>
      </div>
    </div>

    <Button className="btn-orange add-btn" onClick={() => setShowAdd(true)}>
      + Add Note
    </Button>

  </div>

 
</div>

      {/* ================= NOTE 1 ================= */}
      <Card className="note-card mb-3">
        <Card.Body>

          {/* TOP */}
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-2 align-items-center">
              <img
                src="https://i.pravatar.cc/40"
                className="avatar"
                alt=""
              />
              <div>
                <strong>Darlee Robertson</strong>
                <div className="small text-muted">
                  15 Sep 2023, 12:10 pm
                </div>
              </div>
            </div>

            <div className="icons">
              <FiEdit />
              <FiTrash2 />
            </div>
          </div>

          <p className="small mt-2">Notes added by Antony</p>

          <p className="note-text">
            A project review evaluates the success of an initiative and identifies areas for improvement...
          </p>

          {/* FILES */}
          <div className="file-row">
            <div className="file-box green">
              <div className="file-icon">XLS</div>
              <div>
                <p>Project Specs.xls</p>
                <small>365 KB</small>
              </div>
              <FiDownload />
            </div>

            <div className="file-box green">
              <div className="file-icon">XLS</div>
              <div>
                <p>090224.jpg</p>
                <small>365 KB</small>
              </div>
              <FiDownload />
            </div>
          </div>

          {/* ADD COMMENT */}
          <div className="text-end mt-2">
            <span
              className="add-comment"
              onClick={() =>
                setActiveComment(activeComment === 1 ? null : 1)
              }
            >
              <FiMessageCircle /> Add Comment
            </span>
          </div>

          {/* COMMENT EDITOR */}
          {activeComment === 1 && (
            <div className="comment-box">
              <div className="toolbar">
                <select><option>14</option></select>
                <button>B</button>
                <button>I</button>
                <button>U</button>
                <button>S</button>

                <FiImage onClick={() => setShowImage(true)} />
              </div>

              <textarea
                placeholder="Write a new comment..."
                className="form-control"
              />

              <div className="text-end mt-2">
                <Button size="sm" variant="light">Cancel</Button>
                <Button size="sm" className="btn-orange ms-2">Save</Button>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* ================= NOTE 2 ================= */}
      <Card className="note-card">
        <Card.Body>

          <div className="d-flex justify-content-between">
            <div className="d-flex gap-2 align-items-center">
              <img src="https://i.pravatar.cc/41" className="avatar" alt="" />
              <div>
                <strong>Sharon Roy</strong>
                <div className="small text-muted">
                  18 Sep 2023, 09:52 am
                </div>
              </div>
            </div>

            <div className="icons">
              <FiEdit />
              <FiTrash2 />
            </div>
          </div>

          <p className="small mt-2">Notes added by Antony</p>

          <p className="note-text">
            A project plan typically contains a list of essential elements...
          </p>

          <div className="file-box purple">
            <div className="file-icon">TXT</div>
            <div>
              <p>Andrewpass.txt</p>
              <small>365 KB</small>
            </div>
            <FiDownload />
          </div>

          {/* REPLY BOX */}
          <div className="reply-box mt-3">
            The best way to get a project done faster is to start sooner...
            <div className="small mt-2">
              Commented by <span className="text-orange">Aeron</span> on 15 Sep 2023
            </div>

            <Button size="sm" className="btn-dark mt-2">Reply</Button>
          </div>

          <div className="text-end mt-2">
            <span className="add-comment">
              <FiMessageCircle /> Add Comment
            </span>
          </div>

        </Card.Body>
      </Card>

      {/* ================= ADD NOTE MODAL ================= */}
<Modal show={showAdd} onHide={() =>setShowAdd(false)} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">
          Add New Note
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* TITLE */}
        <Form.Group className="mb-3">
          <label className="form-label">
            Title <span className="text-danger">*</span>
          </label>
          <Form.Control className="input-box" />
        </Form.Group>

        {/* NOTE */}
        <Form.Group className="mb-3">
          <label className="form-label">
            Note <span className="text-danger">*</span>
          </label>
          <Form.Control as="textarea" rows={4} className="input-box" />
        </Form.Group>

        {/* ATTACHMENT */}
        <div className="mb-3">
          <label className="form-label">
            Attachment <span className="text-danger">*</span>
          </label>

          <div className="upload-box text-center">
            <div className="upload-icon">
              <FiUpload size={22} />
            </div>

            <p className="mb-2">Drag and drop your files</p>

            <Button
              className="btn-orange"
              size="sm"
              onClick={() => fileRef.current.click()}
            >
              Upload
            </Button>

            <input
              type="file"
              hidden
              ref={fileRef}
              onChange={handleUpload}
            />
          </div>
        </div>

        {/* UPLOADED FILES */}
        <div>
          <p className="fw-medium mb-2">Uploaded Files</p>

          {files.map((file, index) => (
            <div key={index} className="file-item">

              <div className="file-info">
                <p className="mb-1">{file.name}</p>
                <small className="text-muted">{file.size}</small>

                {file.progress && (
                  <>
                    <div className="progress mt-2">
                      <div
                        className="progress-bar"
                        style={{ width: `${file.progress}%` }}
                      ></div>
                    </div>
                    <small>{file.progress}%</small>
                  </>
                )}
              </div>

              {!file.progress && (
                <FiTrash2
                  className="delete-icon"
                  onClick={() => removeFile(index)}
                />
              )}
            </div>
          ))}
        </div>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="light">Cancel</Button>
        <Button className="btn-orange">Save</Button>
      </Modal.Footer>

      {/* EXACT STYLES */}
      <style>{`
        .input-box {
          border-radius: 5px;
          border: 2px solid #ddd;
        }

        .upload-box {
          border: 1px dashed #ddd;
          border-radius: 8px;
          padding: 25px;
          background: #fafafa;
        }

        .upload-icon {
          width: 50px;
          height: 50px;
          margin: auto;
          border-radius: 50%;
          background: #ffe9dd;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ff6a00;
          margin-bottom: 10px;
        }

        .btn-orange {
          background: #ff6a00;
          border: none;
          padding: 5px 14px;
        }
          .sort-select:hover {
    border-color: #f26522;
    background-color: #fffaf5;           /* very light orange tint */
    box-shadow: 0 1px 3px rgba(242, 101, 34, 0.12);
  }

        .file-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f5f7fa;
          padding: 12px;
          border-radius: 6px;
          margin-bottom: 10px;
        }

        .progress {
          height: 6px;
          background: #e9ecef;
          border-radius: 10px;
        }

        .progress-bar {
          background: #28c76f;
          border-radius: 10px;
        }

        .delete-icon {
          color: red;
          cursor: pointer;
        }
      `}</style>
    </Modal>
      {/* ================= INSERT IMAGE MODAL ================= */}
      <Modal show={showImage} onHide={() => setShowImage(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Insert Image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input type="file" className="form-control mb-2" />
          <input type="text" className="form-control" placeholder="Image URL" />
        </Modal.Body>

        <Modal.Footer>
          <Button className="btn-orange">Insert Image</Button>
        </Modal.Footer>
      </Modal>

      {/* STYLES */}
      <style>{`
       /* ===== HEADER LAYOUT ===== */
       .notes-wrapper{
  
              align-items: center;
          border: 1px solid #eee;
          padding: 10px;
          border-radius: 6px;
          background:#ffffff;

       }
    .notes-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
    }

    .header-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
    }

    .sort-group {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .sort-label {
      font-size: 13px;
      color: #6c757d;
      white-space: nowrap;
    }

    .sort-wrapper {
      min-width: 200px;
    }

    .sort-select {
      height: 38px; /* ✅ match button */
      border-radius: 6px;
      padding-right: 2rem;
    }

    /* Arrow */
    .sort-wrapper::after {
      content: "▼";
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      color: #f26522;
      font-size: 0.7rem;
    }

    /* Button */
    .add-btn {
      height: 38px;
      padding: 0 14px;
      white-space: nowrap;
    }

    .btn-orange {
      background: #ff6a00;
      border: none;
    }

    /* ===== MOBILE FIX ===== */
    @media (max-width: 576px) {

      .notes-header {
        flex-direction: column;
        align-items: stretch;
      }

      .header-actions {
        width: 100%;
        justify-content: space-between;
      }

      .sort-group {
        flex: 1;
      }

      .sort-wrapper {
        width: 100%;
      }

      .sort-select {
        width: 100%;
      }

      .add-btn {
        flex-shrink: 0;
      }
    }

        .note-card {
          border: 2px solid #eee;
          border-radius: 9px;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .icons svg {
          margin-left: 10px;
          cursor: pointer;
        }

        .file-row {
          display: flex;
          gap: 10px;
          margin-top: 10px;
        }

        .file-box {
          display: flex;
          gap: 10px;
          align-items: center;
          border: 1px solid #eee;
          padding: 10px;
          border-radius: 6px;
          min-width: 200px;
        }

        .file-icon {
          background: green;
          color: white;
          padding: 6px;
          border-radius: 6px;
          font-size: 12px;
        }

        .file-box.purple .file-icon {
          background: purple;
        }

        .add-comment {
          color: #ff6a00;
          cursor: pointer;
        }

        .comment-box {
          border: 1px solid #ddd;
          padding: 10px;
          margin-top: 10px;
        }

        .toolbar {
          display: flex;
          gap: 6px;
          align-items: center;
        }

        .reply-box {
          background: #f5f7fa;
          padding: 10px;
          border-radius: 6px;
        }

        .btn-orange {
          background: #ff6a00;
          border: none;
        }

        .sort-box {
          padding: 6px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }
       @media(max-width:768px){
           .file-row {
          display: flex;
          gap: 10px;
          margin-top: 10px;
                 flex-wrap: wrap;
        }
        }
          @media(max-width:576px){
           .file-row {
          display: flex;
          gap: 10px;
          margin-top: 10px;
                 flex-wrap: wrap;
        }
        }
      `}</style>
    </div>
  );
}